document.addEventListener("DOMContentLoaded", function () {
  const openButtons = document.querySelectorAll(".contact-popup-wrapper button");
  const closeButtons = document.querySelectorAll(".close-contact-popup");
  const allPopups = document.querySelectorAll(".contact-popup-overlay");

  const webhookUrl = "https://eoqmg5nqfu3dc9r.m.pipedream.net";

  openButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const popup = button.closest(".contact-popup-wrapper")?.querySelector(".contact-popup-overlay");
      if (popup) popup.style.display = "flex";
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const popup = btn.closest(".contact-popup-overlay");
      if (popup) popup.style.display = "none";
    });
  });

  allPopups.forEach((overlay) => {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) overlay.style.display = "none";
    });
  });

  document.querySelectorAll("#contact_form").forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const name = form.querySelector('input[name="name"]').value.trim();
      const email = form.querySelector('input[name="email"]').value.trim();
      const message = form.querySelector('textarea[name="message"]').value.trim();

      fetch(webhookUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message })
      })
        .then((response) => {
          if (response.ok) {
            alert("✅ Sent! Check your email.");
            form.reset();
            const popup = form.closest(".contact-popup-overlay");
            if (popup) popup.style.display = "none";
          } else {
            alert("❌ Something went wrong.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("❌ Submission failed. Check console.");
        });
    });
  });
});
